import React from "react";

export const SectionHeading = ({ index, title, subtitle }) => (
  <div className="max-w-3xl">
    <span className="font-mono text-[11px] tracking-[0.3em] text-[#1E90FF]">{index}</span>
    <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold text-[#F3F6FA] leading-tight">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 text-[#C8CED8] text-sm md:text-base leading-relaxed">{subtitle}</p>
    )}
  </div>
);

export default SectionHeading;
